import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { array, bool } from 'prop-types';
import NewsPromoListItem from './NewsPromoListItem';
import OwlCarousel from 'react-owl-carousel';
import { STATIC_PATH } from '../../../../config';

const path = `${STATIC_PATH}/img/themes/carousel-controls`;


const propTypes = {
  promotions: array.isRequired,
  inNewsItem: bool,
};

const defaultProps = {
  promotions: [],
};

const carouselSettings = {
  loop: true,
  mouseDrag: false,
  touchDrag: false,
  items: 1,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  nav: true,
  navText: [`<img src='${path}/left.svg'>`, `<img src='${path}/right.svg'>`]
};

const NewsPromoList = ({ promotions, inNewsItem }) => promotions.length > 0 ? (
  <div className="news-promo-list">
    <OwlCarousel {...carouselSettings}>
      {promotions.map(promo => (
        <NewsPromoListItem theme={4} key={promo.id} {...promo} inNewsItem={inNewsItem} />
      ))}
    </OwlCarousel>
  </div>
) : (
    <div className="card-empty">
      <FormattedMessage id="news.special.no-offers" defaultMessage="No Special Offers" />
    </div>
  )

NewsPromoList.propTypes = propTypes;
NewsPromoList.defaultProps = defaultProps;

export default NewsPromoList;
